import { defineComponent } from 'vue';
import BaseSocials from '../../mixins/BaseSocial/BaseSocial.js';
import getSerialisedParams from '../../utils/getSerialisedParams.js';

/**
 * Hey!
 *
 * SLinkedIn component used for LinkedIn social network
 * @link https://www.linkedin.com
 */
/**
 * Share parameters for link
 * @link https://docs.microsoft.com/en-us/linkedin/consumer/integrations/self-serve/plugins/share-plugin
 */

var SLinkedIn = /* #__PURE__ */defineComponent({
  name: 'SLinkedIn',
  mixins: [BaseSocials('LinkedIn')],
  computed: {
    networkURL: function networkURL() {
      var BASE_URL = 'https://www.linkedin.com/sharing/share-offsite/';
      var shareOptions = this.shareOptions;
      var url = shareOptions.url;
      var serialisedParams = getSerialisedParams({
        url: url
      });
      return "".concat(BASE_URL).concat(serialisedParams);
    }
  },
  render: function render() {
    return this.generateComponent(this.networkURL);
  }
});

export default SLinkedIn;
